module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/features/uikit-cdn/uikit-cdn.component.scss
// module id = ./src/app/features/uikit-cdn/uikit-cdn.component.scss
// module chunks = main